import { getLocaleFromLocalStorage, getShowTranslationKeysFromLocalStorage, setLocaleToLocalStorage } from '../../../../cache';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { Locale } from '../../../../types';
import { LOCALES } from '../../../../utils';
import i18n from 'i18next';
const getBrowserLocale = () => {
    var _a;
    const locale = typeof navigator !== 'undefined'
        ? navigator.languages
            ? navigator.languages[0]
            : (_a = navigator.language) !== null && _a !== void 0 ? _a : navigator['userLanguage']
        : Locale.Russian;
    return locale.split('-')[0].replace(/"/g, '');
};
const showKeysPostProcessor = {
    type: 'postProcessor',
    name: 'showKeys',
    process: (value, key, options) => {
        if (!options.ns || (options.ns === 'translation' && key[0].includes(':'))) {
            return `{{${key[0]}}}`;
        }
        return `{{${options.ns}:${key[0]}}}`;
    }
};
let i18nInitPromise = null;
export const initI18n = (configLocale) => {
    if (i18n.isInitialized) {
        return Promise.resolve();
    }
    if (i18nInitPromise) {
        return i18nInitPromise;
    }
    i18nInitPromise = new Promise(resolve => {
        const loadedLanguageBundles = new Set();
        const postProcess = [];
        let currentLocale = configLocale !== null && configLocale !== void 0 ? configLocale : getLocaleFromLocalStorage();
        if (!currentLocale) {
            const browserLocale = getBrowserLocale();
            if (LOCALES.has(browserLocale)) {
                currentLocale = browserLocale;
                setLocaleToLocalStorage(currentLocale);
            }
        }
        else {
            setLocaleToLocalStorage(currentLocale);
        }
        if (getShowTranslationKeysFromLocalStorage()) {
            postProcess.push('showKeys');
            const styleNode = document.createElement('style');
            styleNode.innerText = '#root *{text-transform: unset !important}';
            document.head.appendChild(styleNode);
        }
        i18n.use(showKeysPostProcessor)
            .use(Backend)
            .use(initReactI18next)
            .init({
            lng: currentLocale,
            fallbackLng: Locale.Russian,
            keySeparator: false,
            interpolation: { escapeValue: false },
            react: { useSuspense: false },
            backend: {
                loadPath: process.env.NODE_ENV === 'development'
                    ? '/i18n-{{lng}}.json'
                    : 'https://cdn.websky.aero/WX2/locales/i18n-{{lng}}.json',
                request: (options, url, payload, callback) => {
                    if (loadedLanguageBundles.has(url)) {
                        return;
                    }
                    loadedLanguageBundles.add(url);
                    fetch(url, {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'omit'
                    })
                        .then(res => {
                        res.text().then(data => callback(null, {
                            data,
                            status: res.status
                        }));
                    })
                        .catch(err => {
                        loadedLanguageBundles.delete(url);
                        callback(err, { status: 500 });
                    });
                },
                parse: (data, language, namespace) => {
                    const bundle = JSON.parse(data);
                    Object.entries(bundle).forEach(([ns, resource]) => {
                        if (!i18n.hasResourceBundle(language, ns)) {
                            i18n.addResourceBundle(language, ns, resource, true, true);
                        }
                    });
                    window['__webskyEngineReady'] = true;
                    return bundle[namespace] || {};
                }
            },
            postProcess
        });
        const finalize = () => {
            i18n.off('loaded', finalize);
            i18n.off('failedLoading', finalize);
            resolve();
        };
        if (i18n.isInitialized) {
            resolve();
        }
        else {
            i18n.on('loaded', finalize);
            i18n.on('failedLoading', finalize);
        }
    });
    return i18nInitPromise;
};
